/**
 * js-tilt — マウスオーバーで 3D チルトするユーティリティ
 *
 * 使い方：
 *   <div class="js-tilt"> ... </div>
 *
 * オプション属性（任意）：
 *   data-tilt-max="15"       最大傾き角度（デフォルト 12deg）
 *   data-tilt-scale="1.04"   ホバー時の拡大率（デフォルト 1.03）
 *   data-tilt-glare="true"   光沢オーバーレイを表示（デフォルト false）
 */

const DEFAULTS = {
  max: 12,
  scale: 1.03,
  glare: false,
  speed: 0.35,   // GSAP duration（秒）
  ease: 'power2.out',
  resetEase: 'power3.out',
  resetSpeed: 0.6,
};

const initTilt = (el) => {
  const max    = parseFloat(el.dataset.tiltMax)   || DEFAULTS.max;
  const scale  = parseFloat(el.dataset.tiltScale) || DEFAULTS.scale;
  const glare  = el.dataset.tiltGlare === 'true'  || DEFAULTS.glare;

  // perspective ラッパーがなければ自身に適用
  gsap.set(el, { transformPerspective: 800, transformStyle: 'preserve-3d' });

  // 光沢レイヤー生成
  let glareEl = null;
  if (glare) {
    glareEl = document.createElement('span');
    glareEl.className = 'js-tilt__glare';
    el.style.position = el.style.position || 'relative';
    el.style.overflow = 'hidden';
    el.appendChild(glareEl);
  }

  const onMove = (e) => {
    const rect   = el.getBoundingClientRect();
    const cx     = rect.left + rect.width  / 2;
    const cy     = rect.top  + rect.height / 2;
    const mouseX = (e.clientX - cx) / (rect.width  / 2);  // -1 〜 1
    const mouseY = (e.clientY - cy) / (rect.height / 2);  // -1 〜 1

    const rotY =  mouseX * max;
    const rotX = -mouseY * max;

    gsap.to(el, {
      rotateX:  rotX,
      rotateY:  rotY,
      scale,
      duration: DEFAULTS.speed,
      ease:     DEFAULTS.ease,
      overwrite: 'auto',
    });

    if (glareEl) {
      const angle  = Math.atan2(mouseY, mouseX) * (180 / Math.PI) + 90;
      const bright = (mouseX * mouseX + mouseY * mouseY) * 0.4;
      gsap.set(glareEl, {
        background: `linear-gradient(${angle}deg, rgba(255,255,255,${bright}) 0%, transparent 70%)`,
      });
    }
  };

  const onLeave = () => {
    gsap.to(el, {
      rotateX: 0,
      rotateY: 0,
      scale:   1,
      duration: DEFAULTS.resetSpeed,
      ease:     DEFAULTS.resetEase,
      overwrite: 'auto',
    });
  };

  el.addEventListener('mousemove',  onMove);
  el.addEventListener('mouseleave', onLeave);

  // cleanup 用
  el._tiltCleanup = () => {
    el.removeEventListener('mousemove',  onMove);
    el.removeEventListener('mouseleave', onLeave);
    if (glareEl) glareEl.remove();
  };
};

export default {
  init() {
    const els = document.querySelectorAll('.js-tilt');
    if (!els.length) return;

    // タッチデバイスでは無効化
    if (window.matchMedia('(hover: none)').matches) return;

    els.forEach(initTilt);
  },
};
